// Inline-SVG bar chart for per-day data ("did anything happen each
// day?"). Tiny, no charting-library dependency.

export type DayPoint = { day: string; count: number };

const WIDTH = 320;
const HEIGHT = 64;
const GAP = 2;

export function Sparkline({
  data,
  label,
  accent = "currentColor",
}: {
  data: DayPoint[];
  label: string;
  accent?: string;
}) {
  const max = Math.max(...data.map((d) => d.count), 1);
  const total = data.reduce((acc, d) => acc + d.count, 0);
  const barWidth = (WIDTH - GAP * (data.length - 1)) / data.length;

  return (
    <div className="border border-ink-800 rounded-md p-4 bg-ink-900/30">
      <div className="flex items-baseline justify-between mb-2">
        <span className="font-mono text-[10px] uppercase tracking-widest text-ink-400">
          {label}
        </span>
        <span className="text-sm tabular-nums text-ink-100">{total}</span>
      </div>
      <svg
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        width="100%"
        height={HEIGHT}
        className="overflow-visible"
        aria-label={`${label} per day`}
      >
        {data.map((d, i) => {
          const h = d.count > 0 ? Math.max(1, (d.count / max) * HEIGHT) : 0;
          const x = i * (barWidth + GAP);
          const y = HEIGHT - h;
          return (
            <rect
              key={d.day}
              x={x}
              y={y}
              width={barWidth}
              height={h}
              fill={accent}
              opacity={d.count > 0 ? 0.85 : 0.15}
              className="hover:opacity-100 transition-opacity"
            >
              <title>{`${d.day}: ${d.count}`}</title>
            </rect>
          );
        })}
      </svg>
      <div className="mt-1 flex justify-between font-mono text-[9px] text-ink-500">
        <span>{data[0]?.day ?? ""}</span>
        <span>{data[data.length - 1]?.day ?? ""}</span>
      </div>
    </div>
  );
}
